import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

//
// Accordion
//
function accordion() {
    const accordions = document.querySelectorAll('.b-accordion');

    accordions.forEach(accordion => {
        const lists = accordion.querySelectorAll('li');

        lists.forEach(list => {
            const anchor = list.querySelector('a');

            if (list) {
                list.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    // Get the question and answer elements within the list item
                    const text = list.querySelector('.answer');
                    const height = text.scrollHeight;

                    // Get the current state of the clicked list item
                    const currentState = list.getAttribute('aria-expanded') === 'true';

                    // Close all other lists
                    lists.forEach(otherList => {
                        if (otherList !== list) {
                            const otherText = otherList.querySelector('.answer');
                            if (otherText) {
                                otherText.style.maxHeight = '0px';
                            }
                            otherList.classList.remove('active');
                            otherList.setAttribute('aria-expanded', 'false');
                        }
                    });

                    // Toggle the current list
                    if (currentState) {
                        // If currently open, close it
                        text.style.maxHeight = '0px';
                        list.classList.remove('active');
                        setTimeout(() => {
                            list.setAttribute('aria-expanded', 'false');
                        }, 300);
                    } else {
                        // If currently closed, open it
                        text.style.maxHeight = height + 'px';
                        list.classList.add('active');
                        setTimeout(() => {
                            list.setAttribute('aria-expanded', 'true');
                        }, 300);
                    }
                });
            }
        });
    });
}
accordion();

function generateFAQSchema() {
    // Check if `faqData` is available globally (via wp_localize_script)
    if (typeof faqData !== 'undefined' && Array.isArray(faqData)) {
        const pageTitle = document.title || 'FAQ';

        // Generate the FAQ Schema
        const faqSchema = {
            "@context": "https://schema.org",
            "@type": 'FAQPage',
            "@id": window.location.href + "#faq",
            "name": pageTitle,
            "mainEntity": faqData.map((faq) => ({
                "@type": "Question",
                "name": faq.question.replace(/<\/?[^>]+(>|$)/g, ""),
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": faq.answer.replace(/<\/?[^>]+(>|$)/g, ""),
                },
            })),
        };

        // Create a <script> tag for the schema
        const schemaScript = document.createElement("script");
        schemaScript.type = "application/ld+json";
        schemaScript.textContent = JSON.stringify(faqSchema, null, 2);

        // Append it to the <head> of the document
        document.head.appendChild(schemaScript);

        console.log("FAQ schema generated and added to <head>.");
    } else {
        console.warn("faqData is not defined or is not an array. Check your wp_localize_script setup.");
    }
}
generateFAQSchema();

//
// count up animation
//
function countUp() {
    const countElements = document.querySelectorAll('.b-count__number');
    if (countElements.length === 0) return;

    countElements.forEach((element, index) => {
        const startText = element.dataset.start ?? '0';
        const endText = element.dataset.end ?? element.textContent;
        const startNumber = parseFloat(startText);
        const endNumber = parseFloat(endText);

        // Detect decimals
        const hasDecimals = endText.includes('.');
        const decimalPlaces = hasDecimals ? (endText.split('.')[1] || '').length : 0;

        let hasAnimated = false;
        element.textContent = startNumber.toFixed(decimalPlaces);

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !hasAnimated) {
                    hasAnimated = true;
                    setTimeout(() => {
                        animateCount(element, startNumber, endNumber, decimalPlaces);
                    }, 600)
                    observer.unobserve(element);
                }
            });
        }, { threshold: 0.5, rootMargin: '0px 0px -10% 0px' });

        observer.observe(element);
    });
}
// countUp();

function animateCount(element, start, end, decimalPlaces = 0) {
    const duration = 1500;
    const steps = 60;
    const stepDuration = duration / steps;
    let current = start;
    let step = 0;
    const increment = (end - start) / steps;

    const timer = setInterval(() => {
        step++;
        current = start + increment * step;

        // Clamp current value to not overshoot
        if ((increment > 0 && current > end) || (increment < 0 && current < end)) {
            current = end;
        }

        // Format number
        let formattedNumber = decimalPlaces > 0
            ? current.toFixed(decimalPlaces)
            : Math.round(current).toLocaleString();

        element.textContent = formattedNumber;

        // Stop at end
        if (step >= steps || current === end) {
            clearInterval(timer);
            // Ensure final value
            element.textContent = decimalPlaces > 0
                ? end.toFixed(decimalPlaces)
                : Math.round(end).toLocaleString();
        }
    }, stepDuration);
}

// //
// // Activate bars in .b-fifty_fifty__code one at a time when they enter the center of viewport
// //
// function activateCodeBars() {
//     const codeBlocks = document.querySelectorAll('.b-fifty_fifty__code');

//     if (codeBlocks.length === 0) {
//         console.log('No code blocks found');
//         return;
//     }

//     console.log(`Found ${codeBlocks.length} code blocks`);

//     codeBlocks.forEach(codeBlock => {
//         const bars = codeBlock.querySelectorAll('.bar');

//         if (bars.length === 0) {
//             console.log('No bars found in code block');
//             return;
//         }

//         console.log(`Found ${bars.length} bars in code block`);

//         // Set the first bar as active initially
//         bars[0].classList.add('active');

//         // Create intersection observer for bars
//         const observer = new IntersectionObserver((entries) => {
//             entries.forEach(entry => {
//                 if (entry.isIntersecting) {
//                     // Remove active class from all bars
//                     bars.forEach(bar => bar.classList.remove('active'));

//                     // Add active class to the current bar
//                     entry.target.classList.add('active');
//                     console.log('Bar activated:', entry.target);
//                 }
//             });
//         }, {
//             threshold: 0.1, // Trigger when 10% of the element is visible
//             rootMargin: '-45% 0px -45% 0px' // Target exact center of the viewport
//         });

//         // Observe all bars
//         bars.forEach(bar => {
//             observer.observe(bar);
//         });
//     });
// }

// // Initialize bar activation
// activateCodeBars();

// //
// // Confetti effect when elements with class 'confetti-trigger' come into view
// //
// function createConfetti() {
//     // Look for elements with class 'confetti-trigger' or id 'confetti'
//     const confettiElements = document.querySelectorAll('.confetti-trigger, #confetti');

//     if (confettiElements.length === 0) {
//         console.log('No confetti trigger elements found');
//         return;
//     }

//     console.log(`Found ${confettiElements.length} confetti trigger elements, setting up intersection observers`);

//     confettiElements.forEach((confettiElement, index) => {
//         let hasTriggered = false;

//         const observer = new IntersectionObserver((entries) => {
//             entries.forEach(entry => {
//                 if (entry.isIntersecting && !hasTriggered) {
//                     console.log(`Confetti element ${index + 1} came into view, triggering confetti!`);
//                     hasTriggered = true;
//                     launchConfetti(confettiElement);
//                     // Optional: Stop observing after first trigger
//                     // observer.unobserve(confettiElement);
//                 }
//             });
//         }, {
//             threshold: 0.5, // Trigger when 50% of the element is visible
//             rootMargin: '0px 0px -10% 0px'
//         });

//         observer.observe(confettiElement);
//     });
// }

// function launchConfetti(confettiElement) {
//     const section = confettiElement.closest('section') || confettiElement.parentElement;

//     if (!section) {
//         console.log('No section found for confetti element');
//         return;
//     }

//     // Create a unique confetti overlay for this specific section
//     const overlayId = `confetti-overlay-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
//     const confettiOverlay = document.createElement('div');
//     confettiOverlay.className = 'confetti-overlay';
//     confettiOverlay.id = overlayId;
//     confettiOverlay.style.position = 'fixed';
//     confettiOverlay.style.pointerEvents = 'none';
//     confettiOverlay.style.zIndex = '9999';
//     confettiOverlay.style.overflow = 'hidden';
//     document.body.appendChild(confettiOverlay);

//     // Get the section's bounding box to confine confetti to that area
//     const sectionRect = section.getBoundingClientRect();
//     confettiOverlay.style.top = sectionRect.top + 'px';
//     confettiOverlay.style.left = sectionRect.left + 'px';
//     confettiOverlay.style.width = sectionRect.width + 'px';
//     confettiOverlay.style.height = sectionRect.height + 'px';

//     const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FECA57', '#FF9FF3', '#54A0FF'];
//     const confettiCount = 150;

//     for (let i = 0; i < confettiCount; i++) {
//         createConfettiPiece(colors[Math.floor(Math.random() * colors.length)], confettiOverlay, sectionRect.height);
//     }
// }

// function createConfettiPiece(color, container, containerHeight) {
//     const confetti = document.createElement('div');

//     confetti.style.position = 'absolute';
//     confetti.style.width = Math.random() * 10 + 5 + 'px';
//     confetti.style.height = Math.random() * 10 + 5 + 'px';
//     confetti.style.backgroundColor = color;
//     confetti.style.left = Math.random() * 100 + '%';
//     confetti.style.top = '-10px';
//     confetti.style.zIndex = '1';
//     confetti.style.pointerEvents = 'none';
//     confetti.style.borderRadius = Math.random() > 0.5 ? '50%' : '0';
//     confetti.style.opacity = Math.random() * 0.8 + 0.2;
//     confetti.style.willChange = 'transform, opacity';

//     container.appendChild(confetti);

//     // Animate the confetti falling within the specific section bounds
//     const animation = confetti.animate([
//         {
//             transform: 'translateY(0) rotate(0deg)',
//             opacity: confetti.style.opacity
//         },
//         {
//             transform: `translateY(${containerHeight + 20}px) rotate(${Math.random() * 360}deg)`,
//             opacity: 0
//         }
//     ], {
//         duration: Math.random() * 3000 + 2000, // 2-5 seconds
//         easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'
//     });

//     // Remove the confetti element when animation completes
//     animation.addEventListener('finish', () => {
//         confetti.remove();
//         // Clean up overlay if no more confetti pieces
//         if (container.children.length === 0) {
//             // Add a small delay to ensure all animations complete before cleanup
//             setTimeout(() => {
//                 if (container.children.length === 0 && container.parentNode) {
//                     container.remove();
//                 }
//             }, 100);
//         }
//     });
// }

// // Initialize confetti effect
// createConfetti();

// //
// // Responsive Logo Grid - dynamically update SVG grid based on screen size
// //
// function responsiveLogoGrid() {
//     const gridContainers = document.querySelectorAll('.b-logos .grid-lines');

//     if (gridContainers.length === 0) {
//         console.log('No logo grid containers found');
//         return;
//     }

//     console.log(`Found ${gridContainers.length} logo grid containers`);

//     // Define breakpoints (should match your SCSS variables)
//     const breakpoints = {
//         mobile: 768,   // Below this = mobile
//         tablet: 1024   // Below this = tablet, above = desktop
//     };

//     // Define grid configurations for each breakpoint (must match CSS exactly)
//     const gridConfigs = {
//         mobile: { columns: 2, logosPerRow: 1 },         // 2 columns, 1 logo per row
//         tablet: { columns: 6, logosPerRow: 3 },         // 8 columns, 4 logos per row (each spans 2)
//         desktop: { columns: 10, logosPerRow: 5 }        // 10 columns, 5 logos per row (each spans 2)
//     };

//     function getScreenSize() {
//         const width = window.innerWidth;
//         if (width < breakpoints.mobile) return 'mobile';
//         if (width < breakpoints.tablet) return 'tablet';
//         return 'desktop';
//     }

//     function updateGrid(container) {
//         const svg = container.querySelector('svg');
//         if (!svg) return;

//         const screenSize = getScreenSize();
//         const config = gridConfigs[screenSize];
//         const swiperWrapper = container.closest('.swiper-wrapper');

//         if (!swiperWrapper) return;

//         // Get row count from CSS custom property or calculate
//         const computedStyle = getComputedStyle(swiperWrapper);
//         const logoRows = parseInt(computedStyle.getPropertyValue('--logo-rows')) || 4;

//         // Count actual VISIBLE logos on the page to calculate proper row count for current screen size
//         const logoElements = swiperWrapper.querySelectorAll('.b-logos__logo');
//         const visibleLogos = Array.from(logoElements).filter(logo => {
//             const style = window.getComputedStyle(logo);
//             return style.display !== 'none';
//         });
//         const logoCount = visibleLogos.length;

//         console.log(`Found ${logoElements.length} total logos, ${logoCount} visible on ${screenSize}`);

//         // Calculate rows based on visible logos and current screen configuration
//         const logosForThisScreen = Math.ceil(logoCount / config.logosPerRow);
//         const totalRows = logosForThisScreen + 1; // Add 1 for header row

//         console.log(`Updating grid for ${screenSize}: ${config.columns} columns, ${totalRows} rows`);

//         // Clear existing content
//         svg.innerHTML = '';

//         // Create SVG pattern
//         const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
//         const pattern = document.createElementNS('http://www.w3.org/2000/svg', 'pattern');

//         pattern.setAttribute('id', 'grid-pattern');
//         pattern.setAttribute('width', `${100 / config.columns}%`);
//         pattern.setAttribute('height', `${100 / totalRows}%`);
//         pattern.setAttribute('patternUnits', 'objectBoundingBox');

//         // Add vertical line
//         const vLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
//         vLine.setAttribute('x1', '0%');
//         vLine.setAttribute('y1', '0%');
//         vLine.setAttribute('x2', '0%');
//         vLine.setAttribute('y2', '100%');
//         vLine.setAttribute('stroke', 'rgba(255, 255, 255, 0.0835)');
//         vLine.setAttribute('stroke-width', '1');

//         // Add horizontal line
//         const hLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
//         hLine.setAttribute('x1', '0%');
//         hLine.setAttribute('y1', '0%');
//         hLine.setAttribute('x2', '100%');
//         hLine.setAttribute('y2', '0%');
//         hLine.setAttribute('stroke', 'rgba(255, 255, 255, 0.0835)');
//         hLine.setAttribute('stroke-width', '1');

//         pattern.appendChild(vLine);
//         pattern.appendChild(hLine);
//         defs.appendChild(pattern);
//         svg.appendChild(defs);

//         // Apply pattern to main area
//         const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
//         rect.setAttribute('width', '100%');
//         rect.setAttribute('height', '100%');
//         rect.setAttribute('fill', 'url(#grid-pattern)');
//         svg.appendChild(rect);

//         // Add closing borders
//         const rightBorder = document.createElementNS('http://www.w3.org/2000/svg', 'line');
//         rightBorder.setAttribute('x1', '100%');
//         rightBorder.setAttribute('y1', '0%');
//         rightBorder.setAttribute('x2', '100%');
//         rightBorder.setAttribute('y2', '100%');
//         rightBorder.setAttribute('stroke', 'rgba(255, 255, 255, 0.0835)');
//         rightBorder.setAttribute('stroke-width', '1');
//         svg.appendChild(rightBorder);

//         const bottomBorder = document.createElementNS('http://www.w3.org/2000/svg', 'line');
//         bottomBorder.setAttribute('x1', '0%');
//         bottomBorder.setAttribute('y1', '100%');
//         bottomBorder.setAttribute('x2', '100%');
//         bottomBorder.setAttribute('y2', '100%');
//         bottomBorder.setAttribute('stroke', 'rgba(255, 255, 255, 0.0835)');
//         bottomBorder.setAttribute('stroke-width', '1');
//         svg.appendChild(bottomBorder);

//         // Add extension lines and circles
//         addExtensions(svg, config.columns, totalRows);
//     }

//     function addExtensions(svg, columns, totalRows) {
//         const columnWidth = 100 / columns;
//         const rowHeight = 100 / totalRows;

//         // Left extension (3 columns)
//         for (let i = 1; i <= 3; i++) {
//             const x = -(i * columnWidth);

//             // Vertical line
//             const vLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
//             vLine.setAttribute('x1', `${x}%`);
//             vLine.setAttribute('y1', '0%');
//             vLine.setAttribute('x2', `${x}%`);
//             vLine.setAttribute('y2', '100%');
//             vLine.setAttribute('stroke', 'rgba(255, 255, 255, 0.0835)');
//             vLine.setAttribute('stroke-width', '1');
//             svg.appendChild(vLine);

//             // Horizontal lines for this column
//             for (let row = 0; row <= totalRows; row++) {
//                 const y = row * rowHeight;
//                 const hLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
//                 hLine.setAttribute('x1', `${x}%`);
//                 hLine.setAttribute('y1', `${y}%`);
//                 hLine.setAttribute('x2', `${-((i - 1) * columnWidth)}%`);
//                 hLine.setAttribute('y2', `${y}%`);
//                 hLine.setAttribute('stroke', 'rgba(255, 255, 255, 0.0835)');
//                 hLine.setAttribute('stroke-width', '1');
//                 svg.appendChild(hLine);
//             }
//         }

//         // Right extension (3 columns)
//         for (let i = 1; i <= 3; i++) {
//             const x = 100 + (i * columnWidth);

//             // Vertical line
//             const vLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
//             vLine.setAttribute('x1', `${x}%`);
//             vLine.setAttribute('y1', '0%');
//             vLine.setAttribute('x2', `${x}%`);
//             vLine.setAttribute('y2', '100%');
//             vLine.setAttribute('stroke', 'rgba(255, 255, 255, 0.0835)');
//             vLine.setAttribute('stroke-width', '1');
//             svg.appendChild(vLine);

//             // Horizontal lines for this column
//             for (let row = 0; row <= totalRows; row++) {
//                 const y = row * rowHeight;
//                 const hLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
//                 hLine.setAttribute('x1', `${100 + ((i - 1) * columnWidth)}%`);
//                 hLine.setAttribute('y1', `${y}%`);
//                 hLine.setAttribute('x2', `${x}%`);
//                 hLine.setAttribute('y2', `${y}%`);
//                 hLine.setAttribute('stroke', 'rgba(255, 255, 255, 0.0835)');
//                 hLine.setAttribute('stroke-width', '1');
//                 svg.appendChild(hLine);
//             }
//         }

//         // Top and bottom extensions (2 rows each)
//         for (let i = 1; i <= 2; i++) {
//             // Top extension
//             const topY = -(i * rowHeight);
//             const topLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
//             topLine.setAttribute('x1', '-30%');
//             topLine.setAttribute('y1', `${topY}%`);
//             topLine.setAttribute('x2', '130%');
//             topLine.setAttribute('y2', `${topY}%`);
//             topLine.setAttribute('stroke', 'rgba(255, 255, 255, 0.0835)');
//             topLine.setAttribute('stroke-width', '1');
//             svg.appendChild(topLine);

//             // Bottom extension
//             const bottomY = 100 + (i * rowHeight);
//             const bottomLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
//             bottomLine.setAttribute('x1', '-30%');
//             bottomLine.setAttribute('y1', `${bottomY}%`);
//             bottomLine.setAttribute('x2', '130%');
//             bottomLine.setAttribute('y2', `${bottomY}%`);
//             bottomLine.setAttribute('stroke', 'rgba(255, 255, 255, 0.0835)');
//             bottomLine.setAttribute('stroke-width', '1');
//             svg.appendChild(bottomLine);
//         }

//         // Add intersection circles
//         addIntersectionCircles(svg, columns, totalRows, columnWidth, rowHeight);
//     }

//     function addIntersectionCircles(svg, columns, totalRows, columnWidth, rowHeight) {
//         // Main grid circles
//         for (let row = 0; row <= totalRows; row++) {
//             for (let col = 0; col <= columns; col++) {
//                 const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
//                 circle.setAttribute('cx', `${col * columnWidth}%`);
//                 circle.setAttribute('cy', `${row * rowHeight}%`);
//                 circle.setAttribute('r', '2.5');
//                 circle.setAttribute('fill', '#494A63');
//                 svg.appendChild(circle);
//             }
//         }

//         // Extension circles (left, right, top, bottom)
//         for (let row = 0; row <= totalRows; row++) {
//             // Left extension
//             for (let i = 1; i <= 3; i++) {
//                 const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
//                 circle.setAttribute('cx', `${-(i * columnWidth)}%`);
//                 circle.setAttribute('cy', `${row * rowHeight}%`);
//                 circle.setAttribute('r', '2.5');
//                 circle.setAttribute('fill', '#494A63');
//                 svg.appendChild(circle);
//             }

//             // Right extension
//             for (let i = 1; i <= 3; i++) {
//                 const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
//                 circle.setAttribute('cx', `${100 + (i * columnWidth)}%`);
//                 circle.setAttribute('cy', `${row * rowHeight}%`);
//                 circle.setAttribute('r', '2.5');
//                 circle.setAttribute('fill', '#494A63');
//                 svg.appendChild(circle);
//             }
//         }

//         // Top and bottom extension circles
//         for (let i = 1; i <= 2; i++) {
//             for (let col = -3; col <= columns + 3; col++) {
//                 // Top extension
//                 const topCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
//                 topCircle.setAttribute('cx', `${col * columnWidth}%`);
//                 topCircle.setAttribute('cy', `${-(i * rowHeight)}%`);
//                 topCircle.setAttribute('r', '2.5');
//                 topCircle.setAttribute('fill', '#494A63');
//                 svg.appendChild(topCircle);

//                 // Bottom extension
//                 const bottomCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
//                 bottomCircle.setAttribute('cx', `${col * columnWidth}%`);
//                 bottomCircle.setAttribute('cy', `${100 + (i * rowHeight)}%`);
//                 bottomCircle.setAttribute('r', '2.5');
//                 bottomCircle.setAttribute('fill', '#494A63');
//                 svg.appendChild(bottomCircle);
//             }
//         }
//     }

//     // Update all grids initially
//     gridContainers.forEach(updateGrid);

//     // Update grids on window resize
//     let resizeTimeout;
//     window.addEventListener('resize', () => {
//         clearTimeout(resizeTimeout);
//         resizeTimeout = setTimeout(() => {
//             console.log('Window resized, updating logo grids');
//             gridContainers.forEach(updateGrid);
//         }, 250); // Debounce resize events
//     });
// }

// // Initialize responsive logo grid
// // responsiveLogoGrid();

// //
// // Nested Tab System
// //
// function initTabs() {
//     const tabContainers = document.querySelectorAll('.b-tabs');
//     if (tabContainers.length === 0) return;

//     tabContainers.forEach(container => {
//         // Handle parent tabs
//         const parentTabs = container.querySelectorAll('.b-tabs__tab--parent');
//         parentTabs.forEach(tab => {
//             tab.addEventListener('click', () => {
//                 const tabId = tab.dataset.tab;
//                 const parentNav = tab.closest('.b-tabs__nav--parent');

//                 // Remove active class from all parent tabs
//                 parentNav.querySelectorAll('.b-tabs__tab--parent').forEach(t => {
//                     t.classList.remove('active');
//                     t.setAttribute('aria-selected', 'false');
//                 });

//                 // Add active class to clicked tab
//                 tab.classList.add('active');
//                 tab.setAttribute('aria-selected', 'true');

//                 // Hide all parent content sections
//                 container.querySelectorAll('.b-tabs__content--parent').forEach(content => {
//                     content.classList.remove('active');
//                 });

//                 // Show the selected parent content
//                 const targetContent = container.querySelector(`[data-content="${tabId}"]`);
//                 if (targetContent) {
//                     targetContent.classList.add('active');
//                 }
//             });
//         });

//         // Handle child tabs
//         const childTabs = container.querySelectorAll('.b-tabs__tab--child');
//         childTabs.forEach(tab => {
//             tab.addEventListener('click', () => {
//                 const tabId = tab.dataset.tab;
//                 const parentId = tab.dataset.parent;
//                 const childNav = tab.closest('.b-tabs__nav--child');
//                 const parentContent = tab.closest('.b-tabs__content--parent');

//                 // Remove active class from all child tabs in this parent
//                 childNav.querySelectorAll('.b-tabs__tab--child').forEach(t => {
//                     t.classList.remove('active');
//                     t.setAttribute('aria-selected', 'false');
//                 });

//                 // Add active class to clicked tab
//                 tab.classList.add('active');
//                 tab.setAttribute('aria-selected', 'true');

//                 // Hide all child content sections in this parent
//                 parentContent.querySelectorAll('.b-tabs__content--child').forEach(content => {
//                     content.classList.remove('active');
//                 });

//                 // Show the selected child content
//                 const targetContent = parentContent.querySelector(`[data-content="${tabId}"]`);
//                 if (targetContent) {
//                     targetContent.classList.add('active');
//                 }
//             });
//         });

//         // Keyboard navigation support
//         const allTabs = container.querySelectorAll('.b-tabs__tab');
//         allTabs.forEach((tab, index) => {
//             tab.addEventListener('keydown', (e) => {
//                 const tabList = tab.closest('.b-tabs__nav');
//                 const tabs = Array.from(tabList.querySelectorAll('.b-tabs__tab'));
//                 const currentIndex = tabs.indexOf(tab);

//                 let targetTab = null;

//                 // Arrow key navigation
//                 if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
//                     e.preventDefault();
//                     targetTab = tabs[currentIndex + 1] || tabs[0];
//                 } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
//                     e.preventDefault();
//                     targetTab = tabs[currentIndex - 1] || tabs[tabs.length - 1];
//                 } else if (e.key === 'Home') {
//                     e.preventDefault();
//                     targetTab = tabs[0];
//                 } else if (e.key === 'End') {
//                     e.preventDefault();
//                     targetTab = tabs[tabs.length - 1];
//                 }

//                 if (targetTab) {
//                     targetTab.focus();
//                     targetTab.click();
//                 }
//             });
//         });
//     });
// }

// //
// // Timeline Carousel Auto-Resize
// //
// function timelineCarouselResize() {
//     const carousels = document.querySelectorAll('.b-timeline__carousel');

//     carousels.forEach(carousel => {
//         const slides = carousel.querySelectorAll('.b-timeline__slide');

//         function resize() {
//             let maxHeight = 0;

//             // Sum up all the content-inner heights to get the total container height needed
//             slides.forEach(slide => {
//                 const contentInner = slide.querySelector('.b-timeline__content-inner');
//                 if (contentInner) {
//                     const height = contentInner.scrollHeight;
//                     if (height > maxHeight) {
//                         maxHeight = height;
//                     }
//                 }
//             });

//             // Add spacing for the transform translateY values (12.7rem above/below)
//             // 12.7rem = ~127px, plus some padding for the marker and spacing
//             const totalHeight = maxHeight + (12.7 * 16); // 12.7rem converted to pixels

//             // Set carousel to calculated height
//             if (totalHeight > 0) {
//                 carousel.style.minHeight = totalHeight + 'px';
//                 console.log('Timeline carousel resized to:', totalHeight);
//             }
//         }

//         // Wait for images to load before calculating heights
//         function waitForImagesAndResize() {
//             const images = carousel.querySelectorAll('img');
//             let loadedCount = 0;

//             if (images.length === 0) {
//                 // No images, resize immediately
//                 setTimeout(resize, 150);
//             } else {
//                 // Wait for all images to load
//                 images.forEach(img => {
//                     if (img.complete) {
//                         loadedCount++;
//                     } else {
//                         img.addEventListener('load', () => {
//                             loadedCount++;
//                             if (loadedCount === images.length) {
//                                 setTimeout(resize, 150);
//                             }
//                         });
//                         img.addEventListener('error', () => {
//                             loadedCount++;
//                             if (loadedCount === images.length) {
//                                 setTimeout(resize, 150);
//                             }
//                         });
//                     }
//                 });

//                 // If all images are already loaded
//                 if (loadedCount === images.length) {
//                     setTimeout(resize, 150);
//                 }
//             }
//         }

//         // Initial resize after content loads
//         waitForImagesAndResize();

//         // Watch for Swiper slide change if it exists
//         if (carousel.swiper) {
//             carousel.swiper.on('slideChange', () => {
//                 setTimeout(resize, 50);
//             });
//         }

//         // Watch for changes with ResizeObserver on the carousel itself
//         const resizeObserver = new ResizeObserver(() => {
//             resize();
//         });

//         carousel.addEventListener('swiperSlideChange', () => {
//             resize();
//         });

//         resizeObserver.observe(carousel);
//     });
// }

// // // Initialize timeline carousel resize
// // timelineCarouselResize();

// // // Re-run on window resize with debounce
// // let resizeTimeout;
// // window.addEventListener('resize', () => {
// //     clearTimeout(resizeTimeout);
// //     resizeTimeout = setTimeout(() => {
// //         timelineCarouselResize();
// //     }, 250);
// // });

// // Initialize tabs
// // initTabs();
